import {Injectable, Inject } from 'ng-metadata/core';

@Injectable()
export class OrganizationOrFacetToggleService {
    private _isOrganizationTree: boolean = true;

    constructor () {}

    set isOrganizationTree(value: boolean) {
        this._isOrganizationTree = value;
    }
    
    get isOrganizationTree(): boolean {
        return this._isOrganizationTree;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/journals/organizationOrFacetToggle/organization-or-facet-toggle.service.ts